const initialState = {
  toolAreaOpen: false,
  clearMessages: false,
  currentToolTab: "users", // chat, settings, users
  unreadMessages: 0,
  unreadPrivateMessages: new Map(),
  unreadPrivateMessagesTotal: 0,
};

const toolarea = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_TOOL_AREA": {
      const toolAreaOpen = !state.toolAreaOpen;
      const unreadMessages =
        toolAreaOpen && state.currentToolTab === "chat"
          ? 0
          : state.unreadMessages;

      return { ...state, toolAreaOpen, unreadMessages };
    }

    case "OPEN_TOOL_AREA": {
      const toolAreaOpen = true;
      const unreadMessages =
        state.currentToolTab === "chat" ? 0 : state.unreadMessages;

      return { ...state, toolAreaOpen, unreadMessages };
    }

    case "CLOSE_TOOL_AREA": {
      const toolAreaOpen = false;
      return { ...state, toolAreaOpen };
    }

    case "SET_TOOL_TAB": {
      const { toolTab } = action.payload;
      const unreadMessages = toolTab === "chat" ? 0 : state.unreadMessages;

      return { ...state, currentToolTab: toolTab, unreadMessages };
    }

    case "ADD_NEW_RESPONSE_MESSAGE": {
      if (state.toolAreaOpen && state.currentToolTab === "chat") {
        return state;
      }
      return { ...state, unreadMessages: state.unreadMessages + 1 };
    }

    case "CLEAR_MESSAGES": {
      const { cid } = action.payload;
      state.unreadPrivateMessagesTotal -=
        state.unreadPrivateMessages.get(cid) || 0;
      state.unreadPrivateMessages.delete(cid);

      let clearMessages = true;
      return { ...state, clearMessages };
    }

    case "ADD_NEW_PRIVATE_RESPONSE_MESSAGE": {
      const { message } = action.payload;
      let chatId;
      if (message.senderId > message.selectedPeerId)
        chatId = message.senderId + message.selectedPeerId;
      else chatId = message.selectedPeerId + message.senderId;
      if (state.unreadPrivateMessages.get(chatId) !== undefined) {
        state.unreadPrivateMessages.set(
          chatId,
          state.unreadPrivateMessages.get(chatId) + 1
        );
        state.unreadPrivateMessagesTotal += 1;
      } else {
        state.unreadPrivateMessages.set(chatId, 1);
        state.unreadPrivateMessagesTotal += 1;
      }
      return {
        ...state,
        unreadPrivateMessages: state.unreadPrivateMessages,
        unreadMessages: state.unreadMessages,
      };
    }

    case "CLEAR_STATE":
      return initialState;

    default:
      return state;
  }
};

export default toolarea;
